export const contracts = {
  contract: 'Contract',
  deleteTitle: 'Delete Contract',
  deleteMessage: 'Are you sure you want to delete this contract?',
  deleteWarning: 'This action cannot be undone.',
  bulkDelete: 'Bulk Delete',
  bulkDeleteTitle: 'Delete Contracts',
  bulkDeleteMessage: 'Are you sure you want to delete {{count}} selected contracts?',
  bulkDeleteWarning: 'This action cannot be undone and will delete all selected contracts.',
  selected: 'selected',
  title: 'Contracts',
  placeholder: {
    search: 'Search...',
  },
  filter: {
    allTypes: 'All types',
    contract: 'Contract',
    quotation: 'Quotation',
    other: 'Other',
    allCustomers: 'All customers',
    searchCustomer: 'Search customer...',
    unknownCustomer: 'Unknown customer',
    showFilters: 'Show filters',
    hideFilters: 'Hide filters'
  },
  fields: {
    name: 'Name',
    client: 'Client',
    customer: 'Customer',
    type: 'Type',
    createdAt: 'Created at',
    status: 'Status',
    actions: 'Actions',
    validStart: 'Valid from',
    validEnd: 'Valid until',
    views: 'Views',
    organization: 'Organization'
  },
  setAsValid: 'Set as valid',
  setAsExpired: 'Set as expired',
  setAsDraft: 'Set as draft',
  changeExcel: 'Change Excel file',
  types: {
    contract: 'Contract',
    quotation: 'Quotation',
    other: 'Other',
  },
  status: {
    draft: 'Draft',
    valid: 'Valid',
    expired: 'Expired',
  },
  noContracts: 'No contracts to display',
  newContract: 'Create new document',
  newTemplate: 'New contract template',
  generateContract: 'Generate contract',
  selectDocumentType: 'Select document type',
  generateContractForClients: 'Generate contract for clients',
  generateQuotation: 'Generate quotation',
  generateOtherDocument: 'Generate other document',
  importData: 'Import data',
  importExcel: 'Import Excel file',
  importDataDescription: 'Import data from Excel file',
  importedData: 'Data imported',
  selectedTemplate: 'Selected contract template',
  selectedTemplateDescription: 'The following contract template will be used for generation',
  contractUpdatedAt: 'Contract updated',
  updatedAt: 'Updated at',
  generateDocument: 'Generate document',
  selectedContract: 'Selected contract',
  selectedFormats: 'formats selected',
  generating: 'Generating...',
  generatingDocument: 'Generating document...',
  generatedDocument: 'Document generated',
  generatedDocumentError: 'Error occurred while generating document',
  generatedDocumentSuccess: 'Document successfully created',
  generateLoadDataFrom: "You can load data from Excel file or manually for contract generation",
  noDataError: "No data available for document generation. Please load data from Excel file or enter manually.",
  emptyDataError: "The dataset is empty. Please load valid data.",
  importExcelModal: {
    title: 'Import Excel file',
    description: 'Select an Excel file containing data for contract generation. The file must contain all required fields used in the template.',
    selectFile: 'Select file',
    supportedFormats: 'Supported formats: .xlsx, .xls, .csv',
    cancel: 'Cancel',
    preview: 'Imported data preview',
    import: 'Import',
  },
  chooseTemplateModal: {
    title: 'Select template',
    description: 'Choose a template for generation.',
    outputFormats: 'Output formats',
    outputFormatsDescription: 'Select output formats (multiple can be selected)',
    selectTemplate: 'Select template',
    searchTemplate: 'Search template',
    newestFirst: 'Newest first',
    oldestFirst: 'Oldest first',
    nameAsc: 'Name (A-Z)',
    nameDesc: 'Name (Z-A)',
    preview: 'Preview',
    noTemplatesFound: 'No templates match the search criteria',
    noTemplatesAvailable: 'No templates available for this type',
    select: 'Select'
  },
  documentPreviewModal: {
    title: 'Document preview',
    documentNotFound: 'Document not found or not accessible.',
    documentNotDisplayable: 'Document cannot be displayed',
    download: 'Download',
    reload: 'Reload',
    openInNewTab: 'Open in new tab',
    documentInformation: 'Document information',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
  },
  manualFill: {
    title: 'Manual data entry',
    editTitle: 'Edit imported data',
    description: 'Enter data manually for the template. You can add multiple data rows.',
    editDescription: 'Edit imported Excel data. You can modify values and add new data rows.',
    noFields: 'No fields in template.',
    fieldPlaceholder: 'Enter value...',
    addNewDataSet: 'Add new data set',
    button: "Manual fill",
    dataRow: "Data row:",
    removeDataSet: "Remove data set"
  },
  actions: {
    view: "View",
    download: "Download",
    share: "Share",
    delete: "Delete"
  },
  shared: "Link copied to clipboard!",
  shareModal: {
    title: "Share Document",
    passwordProtection: "Password Protection",
    password: "Password",
    validUntil: "Valid Until (optional)",
    createLink: "Create Link",
    updateLink: "Update Link",
    linkCreated: "Share link created:",
    copyLink: "Copy Link",
    linkInfo: "Anyone with this link can view the document.",
    linkPasswordInfo: "This link is password protected. Recipient will need to enter the password to view it.",
    editLink: "Edit Link",
    cancelEdit: "Cancel Editing",
    modifySharing: "Modify Sharing",
    viewStats: "View Stats",
    shareSuccessful: "Sharing successful!",
    linkExpiry: "Link expiry time"
  },
  messages: {
    deleted: 'Contract successfully deleted',
    deleteError: 'Error deleting contract',
    bulkDeleted: '{{count}} contracts successfully deleted',
  },
  documentLoadError: 'Error loading document',
  tryDownloadInstead: 'Please try downloading the document instead of viewing it directly',
  browserCannotDisplay: 'Your browser cannot display this PDF document. Please download and open it with an external application.',
  viewCount: '{{count}} views',
  lastViewed: 'Last viewed',
  filterNoResults: 'No documents match your current filters. Try adjusting your search criteria.',
  emptyState: 'You haven\'t created any documents yet. Get started by creating your first document.',
  clearSearch: 'Clear search',
  clearTypeFilter: 'Clear type filter',
  unsupportedFileFormat: 'Unsupported file format',
  cannotPreviewThisFormat: 'This format cannot be previewed. Download the file to open it.',
  clearCustomerFilter: 'Clear customer filter'
}
